import { Card, Segmented } from 'antd';
import { FC, memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';

type RedirectsType = 'local' | 'external';

interface Props {
  siteId: string;
  active: RedirectsType;
}

export const RedirectsTypeSwitch: FC<Props> = memo(({ siteId, active }) => {
  const navigate = useNavigate();

  const handleChange = (value: RedirectsType): void => {
    navigate(
      value === 'local'
        ? AppRoutes.Redirects.replace(':siteId', siteId)
        : AppRoutes.ExternalRedirects.replace(':siteId', siteId)
    );
  };

  return (
    <Card size='small'>
      <Segmented
        block
        value={ active }
        onChange={ handleChange }
        options={ [
          { label: 'Внутрішні', value: 'local' },
          { label: 'Зовнішні', value: 'external' },
        ] }
      />
    </Card>
  );
});
